import { FC } from "react";

interface CurrencyIconSVGProps {
    className?: string;
    strokeWidth?: string;
}

const CurrencyIconSVG: FC<CurrencyIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="33"
            height="32"
            viewBox="0 0 33 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.8337 10.668H13.8337C13.1264 10.668 12.4481 10.9489 11.948 11.449C11.4479 11.9491 11.167 12.6274 11.167 13.3346C11.167 14.0419 11.4479 14.7202 11.948 15.2203C12.4481 15.7203 13.1264 16.0013 13.8337 16.0013H19.167C19.8742 16.0013 20.5525 16.2823 21.0526 16.7824C21.5527 17.2824 21.8337 17.9607 21.8337 18.668C21.8337 19.3752 21.5527 20.0535 21.0526 20.5536C20.5525 21.0537 19.8742 21.3346 19.167 21.3346H11.167M16.5003 24.0013V8.0013M29.8337 16.0013C29.8337 23.3651 23.8641 29.3346 16.5003 29.3346C9.13653 29.3346 3.16699 23.3651 3.16699 16.0013C3.16699 8.6375 9.13653 2.66797 16.5003 2.66797C23.8641 2.66797 29.8337 8.6375 29.8337 16.0013Z"
                stroke="currentColor"
                strokeWidth={props.strokeWidth || "1.5"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CurrencyIconSVG;
